"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Legend = exports.InlineItems = exports.Items = exports.Fieldset = exports.GroupContext = void 0;
var _tslib = require("tslib");
var _react = _interopRequireWildcard(require("react"));
var _formik = require("formik");
var _Layout = require("../../../Layout/");
var _Error = _interopRequireDefault(require("../Error"));
var _Hint = _interopRequireDefault(require("../Hint"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
var GroupContext = (0, _react.createContext)({
  inGroup: false,
  name: ''
});
exports.GroupContext = GroupContext;
var Fieldset = function Fieldset(_a) {
  var _b = _a.variant,
    variant = _b === void 0 ? 'group' : _b,
    props = (0, _tslib.__rest)(_a, ["variant"]);
  return _react.default.createElement(_Layout.Box, (0, _tslib.__assign)({
    __themekey: "forms",
    __css: {
      padding: 0,
      marginBottom: 4,
      border: 'none',
      '&:focus': {
        outline: '1px dotted slategrey'
      },
      '&:focus-within': {
        outline: '1px dotted slategrey'
      }
    },
    variant: variant
  }, props));
};
exports.Fieldset = Fieldset;
Fieldset.displayName = 'FieldSet';
var Items = function Items(_a) {
  var _b = _a.variant,
    variant = _b === void 0 ? 'forms.groupItems' : _b,
    inline = _a.inline,
    props = (0, _tslib.__rest)(_a, ["variant", "inline"]);
  return _react.default.createElement(_Layout.Box, (0, _tslib.__assign)({}, props));
};
exports.Items = Items;
Items.displayName = 'GroupItems';
var InlineItems = function InlineItems(_a) {
  var _b = _a.variant,
    variant = _b === void 0 ? 'forms.groupItems' : _b,
    inline = _a.inline,
    props = (0, _tslib.__rest)(_a, ["variant", "inline"]);
  return _react.default.createElement(_Layout.Flex, (0, _tslib.__assign)({
    __css: {
      display: 'inline-flex',
      flexDirection: 'row',
      flex: '0 0 auto',
      marginRight: 2
    }
  }, props));
};
exports.InlineItems = InlineItems;
Items.displayName = 'GroupInlineItems';
var Legend = function Legend(_a) {
  var _b = _a.variant,
    variant = _b === void 0 ? 'forms.groupLegend' : _b,
    props = (0, _tslib.__rest)(_a, ["variant"]);
  return _react.default.createElement(_Layout.Box, (0, _tslib.__assign)({
    as: "legend"
  }, props));
};
exports.Legend = Legend;
Items.displayName = 'GroupLegend';
var StackedGroup = function StackedGroup(_a) {
  var children = _a.children,
    hint = _a.hint,
    label = _a.label,
    name = _a.name;
  return _react.default.createElement(GroupContext.Provider, {
    value: {
      inGroup: true,
      name: name
    }
  }, _react.default.createElement(Fieldset, {
    as: "fieldset",
    id: name,
    tabIndex: -1
  }, label && _react.default.createElement(Legend, null, label), hint && _react.default.createElement(_Hint.default, {
    pb: 1
  }, hint), _react.default.createElement(_formik.ErrorMessage, {
    component: _Error.default,
    name: name
  }), _react.default.createElement(Items, {
    as: "section",
    hasLabel: !!label
  }, children)));
};
var InlineGroup = function InlineGroup(_a) {
  var children = _a.children,
    hint = _a.hint,
    label = _a.label,
    name = _a.name;
  return _react.default.createElement(GroupContext.Provider, {
    value: {
      inGroup: true,
      name: name
    }
  }, _react.default.createElement(Fieldset, {
    as: "fieldset",
    id: name,
    tabIndex: -1
  }, _react.default.createElement(_Layout.Flex, {
    sx: {
      flexDirection: 'row'
    }
  }, _react.default.createElement(_Layout.Box, {
    sx: {
      order: 1
    }
  }, label && _react.default.createElement(Legend, null, label), hint && _react.default.createElement(_Hint.default, {
    pb: 1
  }, hint), _react.default.createElement(_formik.ErrorMessage, {
    component: _Error.default,
    name: name
  })), _react.default.createElement(InlineItems, {
    as: "section",
    hasLabel: !!label
  }, children))));
};
var Group = function Group(_a) {
  var _b = _a.inline,
    inline = _b === void 0 ? false : _b,
    props = (0, _tslib.__rest)(_a, ["inline"]);
  return inline ? _react.default.createElement(InlineGroup, (0, _tslib.__assign)({}, props)) : _react.default.createElement(StackedGroup, (0, _tslib.__assign)({}, props));
};
var _default = Group;
exports.default = _default;